import { loader } from 'graphql.macro'
import { intercomConnection } from '../../intercomConnection'

export default async function addImageToTicket ({ dataLoaders, variables }) {
  const schema = loader('./addImageToTicket.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: variables })
  intercomConnection.trackEvent('ticket_image_created', {})
  return response.addImageToTicket
}
